<template>
  <div style="padding: 0 15px">
    <Danfe55Header :model="model" />
    <Danfe55GeneralInfos :model="model" class="mt-1" />
    <Danfe55Client :model="model" class="mt-1" />
    <Danfe55Bill :model="model" class="mt-1" />
    <Danfe55BillDuplicates
      v-if="model.bill.duplicates.length > 0"
      :model="model"
      class="mt-1"
    />
    <Danfe55Taxes :model="model" class="mt-1" />
    <Danfe55Transporter :model="model" class="mt-1" />
    <Danfe55Items :model="model" class="mt-1" />
    <Danfe55AdditionalData :model="model" class="mt-1" />
  </div>
</template>

<script>
import Danfe55Header from './components/Danfe55Header.vue';
import Danfe55GeneralInfos from './components/Danfe55GeneralInfos.vue';
import Danfe55Client from './components/Danfe55Client.vue';
import Danfe55Bill from './components/Danfe55Bill.vue';
import Danfe55BillDuplicates from './components/Danfe55BillDuplicates.vue';
import Danfe55Taxes from './components/Danfe55Taxes.vue';
import Danfe55Transporter from './components/Danfe55Transporter.vue';
import Danfe55Items from './components/Danfe55Items.vue';
import Danfe55AdditionalData from './components/Danfe55AdditionalData.vue';

export default {
  name: 'Danfe55',
  components: {
    Danfe55Header,
    Danfe55GeneralInfos,
    Danfe55Client,
    Danfe55Bill,
    Danfe55BillDuplicates,
    Danfe55Taxes,
    Danfe55Transporter,
    Danfe55Items,
    Danfe55AdditionalData,
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
  },
};
</script>
